<template>
  <ic-typeahead
    v-model="searchQuery"
    :id="id"
    :text="searchText"
    :options="searchOptions"
    :getValue="getValueDefault"
    :getText="getTextDefault"
    :selectFirst="selectFirst"
    :onInputChange="onInputChangeDefault"
    :minLength="minLength"
    v-on:update:text="searchText = $event"
    v-on:update:item="searchItem = $event"
    :loading="isLoading"
  >
    <a slot="item" slot-scope="props" href="#" role="option">{{props.item.n}}</a>
  </ic-typeahead>
</template>

<script>
import IcTypeahead from "./TypeAhead.vue";
import axios from "axios";
import VueAxios from "vue-axios";

export default {
  name: "IcAjaxTypeahead",
  props: {
    id: {
      type: String,
      required: true
    },
    text: {
      type: String
    },
    value: {
      type: String
    },
    getValue: {
      type: Function
    },
    getText: {
      type: Function
    },
    url: {
      type: String
    },
    onInputChange: {
      type: Function
    },
    minLength: {
      type: Number,
      default: 3
    },
    selectFirst: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      searchOptions: {
        debounce: 200
      },
      searchQuery: this.value,
      searchText: this.text,
      searchItem: "",
      options: {},
      isLoading: false
    };
  },
  watch: {
    searchQuery: function(newValue) {
      this.$emit("input", newValue);
    },
    searchText: function(newValue) {
      this.$emit("update:text", newValue);
    },
    searchItem: function(newValue) {
      this.$emit("update:item", newValue);
    },
    value: function(newValue) {
      this.searchQuery = newValue;
    },
    text: function(newValue) {
      this.searchText = newValue;
    },
    isLoading: function(newValue) {
      this.$emit("is:loading", this.isLoading);
    }
  },
  components: { IcTypeahead },
  methods: {
    processDataDefault(data) {
      if (this.processData) {
        return this.processData(data);
      }
      let items = [];
      data.forEach(item => {
        items.push(item);
      });
      return items;
    },
    onInputChangeDefault(query) {
      this.isLoading = true;
      if (this.onInputChange) {
        return this.onInputChange(query);
      }
      if (query.trim().length === 0) {
        return null;
      }
      const url = this.url.replace(":query", query);
      return new Promise(resolve => {
        axios.get(url).then(response => {
          let items = this.processDataDefault(response.data);
          resolve(items);
          this.isLoading = false;
        });
      });
    },
    getValueDefault(item) {
      if (this.getValue) {
        return this.getValue(item);
      }
      return item;
    },
    getTextDefault(item) {
      if (this.getText) {
        return this.getText(item);
      }
      return item;
    }
  }
};
</script>

<style>
</style>
